<mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
    <mat-card-content class="mat-mdc-card-content text-center">
        <form [formGroup]="form">
            <div class="row">
                <div class="col-sm-4">
                    <mat-form-field appearance="outline" class="w-100 m-b-10">
                        <mat-label>{{ 'userName' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'userName' | translate }}" formControlName="userName"
                            maxlength="50" />
                        <mat-icon matPrefix class="op-5">
                            <i-tabler name="user" class="icon-20 d-flex"></i-tabler>
                        </mat-icon>
                        @if(f['userName'].touched && f['userName'].invalid)
                        {
                        <mat-hint class="m-b-16 error-msg">
                            @if(f['userName'].errors && f['userName'].errors['required'])
                            {
                            <div class="text-error"> {{ 'EnterUserName' | translate }}</div>
                            }
                        </mat-hint>
                        }
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100 m-b-10">
                        <mat-label>{{ 'Phone' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'Phone' | translate }}" formControlName="phoneNumber"
                            maxlength="11" />
                        <mat-icon matPrefix class="op-5">
                            <i-tabler name="phone" class="icon-20 d-flex"></i-tabler>
                        </mat-icon>
                        @if(f['phoneNumber'].touched && f['phoneNumber'].invalid)
                        {
                        <mat-hint class="m-b-16 error-msg">
                            @if(f['phoneNumber'].errors && f['phoneNumber'].errors['required'])
                            {
                            <div class="text-error"> {{ 'EnterPhone' | translate }}</div>
                            }

                            @if(f['phoneNumber'].errors && f['phoneNumber'].errors['minlength'])
                            {
                            <div class="text-error"> {{ 'LengthPhone' | translate }}</div>
                            }

                            @if(f['phoneNumber'].errors && f['phoneNumber'].errors['pattern'])
                            {
                            <div class="text-error"> {{ 'digitsError' | translate }}</div>
                            }
                        </mat-hint>
                        }
                    </mat-form-field>
                </div>

                <div class="col-sm-4">

                    <mat-form-field appearance="outline" class="w-100 m-b-10">
                        <input matInput [type]="hidePassword ? 'password' : 'text'"
                            placeholder="{{ 'Password' | translate }}" formControlName="password" maxlength="50" />
                        <mat-icon matPrefix class="op-5">
                            <i-tabler name="lock" class="icon-20 d-flex"></i-tabler>
                        </mat-icon>

                        <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword">
                            <mat-icon class="op-5">{{ hidePassword ? "visibility_off" : "visibility"}}</mat-icon>
                        </button>

                        @if(f['password'].touched && f['password'].invalid)
                        {
                        <mat-hint class="m-b-16 error-msg">
                            @if(f['password'].errors && f['password'].errors['required'])
                            {
                            <div class="text-error"> {{ 'EnterPassword' | translate }}</div>
                            }
                        </mat-hint>
                        }
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100 m-b-10">
                        <mat-label>{{ 'Email' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'Email' | translate }}" formControlName="email"
                            maxlength="50" />
                        <mat-icon matPrefix class="op-5">
                            <i-tabler name="mail" class="icon-20 d-flex"></i-tabler>
                        </mat-icon>

                        @if(f['email'].touched && f['email'].invalid)
                        {
                        <mat-hint class="m-b-16 error-msg">
                            @if(f['email'].errors && f['email'].errors['required'])
                            {
                            <div class="text-error"> {{ 'InvalidEmail' | translate }}</div>
                            }
                        </mat-hint>
                        }
                    </mat-form-field>
                </div>
            </div>

            <mat-divider></mat-divider>

            <div class="row m-t-24">
                <div class="col-sm-12">
                    <button mat-flat-button color="primary" class="orangSavebtn" (click)="submit()">
                        {{ 'Save' | translate }}
                    </button>

                    <a (click)="Cancel()" class="Cancelbtn">
                        {{ 'Cancel' | translate}}
                    </a>
                </div>
            </div>
        </form>
    </mat-card-content>
</mat-card>